module.exports = __webpack_public_path__ + "img/try2.0387fcf6.jpg";